interface DollarSignOffIconProps {
  size?: number;
  className?: string;
}

export const DollarSignOffIcon = ({ size = 14, className = '' }: DollarSignOffIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* BadgeDollarSign paths */}
      <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76z" />
      <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
      <line x1="12" y1="18" x2="12" y2="22" />
      <line x1="12" y1="2" x2="12" y2="6" />
      {/* Diagonal slash */}
      <line x1="3" y1="3" x2="21" y2="21" strokeWidth="2.5" />
    </svg>
  );
};
